import { registerEnumType } from 'type-graphql'

export enum WebhookEventEnum {
  queued = 'webhook.queued',
  inProgress = 'webhook.inProgress',
  failed = 'webhook.failed',
  done = 'webhook.done',
}

registerEnumType(WebhookEventEnum, {
  name: 'WebhookEventEnum',
  description: 'Common Event type for webhooks',
})
